import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { ApiDonation, Donation } from '../../types/donations-feed/models';

export const DonationsFeedActions = createActionGroup({
  source: 'DonationsFeed',
  events: {
    'Load Requested': emptyProps(),
    'Load Succeeded': props<{ items: Donation[] }>(),
    'Load Failed': props<{ error: string }>(),

    'Like Toggled Requested': props<{ id: string }>(), // click usuario
    'Like Optimistic': props<{ id: string; delta: 1 | -1; liked: boolean }>(),
    'Like Confirmed': props<{ id: string; likes: number; liked: boolean }>(),
    'Like Reverted': props<{ id: string }>(),

    'Realtime Donation Received': props<{ donation: ApiDonation }>(),
  },
});
